import type { InternalAxiosRequestConfig } from 'axios';
import { businessContext } from '@/store/businessContext';
import { ApiError } from '../api-error';

// Tenant-scoped calls carry the selected business; account-level calls (/auth, /business/me) do not.
export function attachBusinessId(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  if (!config.tenant) return config;

  const businessId = businessContext.get();
  if (!businessId) throw new ApiError(400, 'BUSINESS_CONTEXT_REQUIRED', 'Select a business first');

  config.headers.set('X-Business-Id', businessId);
  return config;
}
